import { createContext } from 'react';
import { LOCALE } from 'src/constants';

export const AppContext = createContext<AppContext>({
    locale: LOCALE.EN,
    setLocale: () => { }
});